import { XmlSchemaNumericFacet } from './XmlSchemaNumericFacet';

export class XmlSchemaFractionDigitsFacet extends XmlSchemaNumericFacet {}
